import { TableCell, TableRow, TextField } from "@mui/material";
import { FC, useState } from "react";
import { DeviseInterface } from "../../content/parametrage/Article/InterfaceArticle";
import CheckAttr from "../../../utils/CheckAttr";
import { TauxInterface } from "../../content/parametrage/TauxEchange/InterfaceTaux";
interface RowTauxDechangeFormAtribute {
  rowDevise: DeviseInterface;
  TauxPerMounth: TauxInterface;
  handleChangeTaux: (tauxByRow: string, idDevise: number) => void;
  DeviseToCheck: number[];
}
const RowTauxDechangeForm: FC<RowTauxDechangeFormAtribute> = ({
  rowDevise,
  TauxPerMounth,
  handleChangeTaux,
  DeviseToCheck,
}) => {
  const [taux, setTaux] = useState<string>(
    TauxPerMounth?.taux?.find((t) => t.devise_id == rowDevise.id)
      ?.rate_euro as string
  );

  const handleChange = (e: any) => {
    setTaux(e.target.value);
    handleChangeTaux(e.target.value, rowDevise?.id);
  };
  return (
    <>
      <TableRow key={rowDevise.id}>
        <TableCell align="center">{rowDevise?.monnaie}</TableCell>
        <TableCell align="center">
          <TextField
            name="tarif_acte"
            label="Taux"
            color="warning"
            fullWidth
            autoComplete="off"
            error={DeviseToCheck.includes(rowDevise.id)}
            value={taux}
            onChange={handleChange}
            InputLabelProps={{
              shrink: CheckAttr(taux),
            }}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default RowTauxDechangeForm;
